import { Component, Prop } from '@stencil/core';
import { UserDTO } from '../../dto/user.dto';
import { environment } from '../../environments/environment';

@Component({
  tag: 'accounts-pendo-analytics',
  styleUrl: 'pendo-analytics.scss'
})
export class PendoAnalytics {
  @Prop() user: UserDTO;

  async componentDidLoad() {
    const self = this;
    (function (apiKey) {
      (function (p, e, n, d, o) {
        let v, w, x, y, z;
        o = p[d] = p[d] || {};
        o._q = o._q || [];
        v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track']; // eslint-disable-line
        for (w = 0, x = v.length; w < x; ++w)
          (function (m) {
            o[m] =
              o[m] ||
              function () {
                o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0))); // eslint-disable-line
              };
          })(v[w]);
        y = e.createElement(n); // eslint-disable-line
        y.async = !0;
        y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
        z = e.getElementsByTagName(n)[0]; // eslint-disable-line
        z.parentNode.insertBefore(y, z);
      })(window, document, 'script', 'pendo');
      // @ts-ignore
      pendo.initialize({
        visitor: {
          id: self.user.id // Required if user is logged in, default creates anonymous ID
        }
      });
    })(environment.pendoAPIKey);
  }

  render() {
    return [];
  }
}
